import { some } from 'lodash';

const isNumericContent = (sup) => {
  return !isNaN(parseInt(sup.textContent, 10));
};

const convertSuperscriptNumberToDagger = (text, disclosures) => {
  const id = parseInt(text, 10);
  if (!disclosures[id]) {
    return text;
  }
  return `<a disclosure="${id}" role="button" class="disclosure">†</a>`;
};

const convertDataDisclosureToAnchor = (el, disclosures) => {
  const id = el.getAttribute('data-disclosure-id');
  const optionType = el.getAttribute('data-type');
  const isPackageOption = optionType && optionType === 'package';
  const num = parseInt(id, 10);
  if (disclosures[num]) {
    if (isPackageOption) {
      el.outerHTML = `<a disclosure="${id}" role="button" class="disclosure disclosure--package">${el.innerHTML}<sup>†</sup></a>`;
    } else {
      el.outerHTML = `<a disclosure="${id}" role="button" class="disclosure">${el.innerHTML}<sup>†</sup></a>`;
    }
  }
};

const replaceStyleDisclosureNumbersWithDaggerDirectives = (
  htmlString,
  disclosures
) => {
  var el = document.createElement('div');
  el.innerHTML = htmlString;

  var sups = Array.prototype.slice.call(el.querySelectorAll('sup'));
  var numericSups = sups.filter(function (x) {
    return isNumericContent(x);
  });
  var nonNumericSups = sups.filter(function (x) {
    return !isNumericContent(x);
  });
  var nonNumericSupsWithNumber = nonNumericSups.filter(function (x) {
    var text = x.textContent;
    var numericMatches = text.match(/\d+/g);
    return some(numericMatches);
  });

  // update markup to replace superscript numbers with disclosure anchor directive
  numericSups.forEach(function (sup) {
    sup.innerHTML = convertSuperscriptNumberToDagger(
      sup.textContent,
      disclosures
    );
  });

  nonNumericSupsWithNumber.forEach(function (x) {
    const text = x.textContent;
    const number = text.match(/\d+/g)[0];
    const nonNumericText = text.replace(/\d+/g, '').trim();

    const nonNumericSupHtml = `<sup>${nonNumericText}</sup>`;
    const numericSupHtml = `<sup>${convertSuperscriptNumberToDagger(
      number,
      disclosures
    )}</sup>`;

    x.outerHTML = `${nonNumericSupHtml}${numericSupHtml}`;
  });

  let elementsWithDataDisclosure = Array.prototype.slice.call(
    el.querySelectorAll('[data-disclosure-id]')
  );
  elementsWithDataDisclosure.forEach(function (el) {
    convertDataDisclosureToAnchor(el, disclosures);
  });

  return el.innerHTML;
};

export const normalizeStyle = (style, disclosures) => {
  const { marketingCopy } = style;
  style.marketingCopy = replaceStyleDisclosureNumbersWithDaggerDirectives(
    marketingCopy,
    disclosures
  );
  return style;
};

export const normalizeEvFeature = (feature, disclosures) => {
  return replaceStyleDisclosureNumbersWithDaggerDirectives(
    feature,
    disclosures
  );
};
